export default __webpack_public_path__ + "static/media/briones-crop.b1822666.jpg";